import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import PasswordInput from './PasswordInput';

export default function RegisterForm({ onSwitch }) {
  const { t } = useTranslation('auth');
  const { register } = useAuth();
  const [form, setForm] = useState({ email: '', display_name: '', password: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const update = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirmPassword) {
      setError(t('passwords_no_match'));
      return;
    }
    setLoading(true);
    try {
      await register({
        email: form.email,
        display_name: form.display_name,
        password: form.password,
      });
    } catch {
      setError(t('registration_failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-card">
      <h1 className="auth-title">{t('register_title')}</h1>
      <p className="auth-subtitle">{t('register_subtitle')}</p>
      {error && <div className="auth-error">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>{t('display_name')}</label>
          <input type="text" value={form.display_name} onChange={update('display_name')} required />
        </div>
        <div className="form-group">
          <label>{t('email')}</label>
          <input type="email" value={form.email} onChange={update('email')} required />
        </div>
        <div className="form-group">
          <label>{t('password')}</label>
          <PasswordInput
            value={form.password}
            onChange={update('password')}
            required
            minLength={6}
            autoComplete="new-password"
          />
        </div>
        <div className="form-group">
          <label>{t('confirm_password')}</label>
          <PasswordInput
            value={form.confirmPassword}
            onChange={update('confirmPassword')}
            required
            autoComplete="new-password"
          />
        </div>
        <button type="submit" className="btn-primary" disabled={loading}>
          {loading ? '...' : t('register')}
        </button>
      </form>
      <p className="auth-switch">
        {t('have_account')} <button className="link-btn" onClick={onSwitch}>{t('login')}</button>
      </p>
    </div>
  );
}
